import React, { useState } from "react";

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "من يمكنه المشاركة؟",
      answer:
        "المطورون العرب فقط — سواء كنت طالبًا أو محترفًا، المهم أن تكون مبرمجًا وتملك شغف التطوير. يمكن للمطورين من أي دولة عربية المشاركة بغض النظر عن مستوى الخبرة.",
      icon: "👤",
    },
    {
      question: "هل التسجيل في nsave إجباري؟",
      answer:
        "نعم، التسجيل في منصة nsave إجباري للمشاركة في الهاكاثون. يجب التسجيل عن طريق رابط الريفيرال التالي: <a class='text-yellow underline' href='https://web.nsave.com/referral/egyptianfreelancers'>https://web.nsave.com/referral/egyptianfreelancers</a> - تأكد من استخدام هذا الرابط للتسجيل.",
      icon: "📝",
    },  {
      question: "هل الهاكاثون عن بُعد؟",
      answer:
        "نعم، يقام بالكامل عبر الإنترنت ليسمح لكل مطور عربي بالمشاركة من أي مكان. ستكون جميع الفعاليات والتواصل عبر منصات رقمية.",
      icon: "🌍",
    },
    {
      question: "هل المشاركة فردية أم جماعية؟",
      answer:
        "يمكنك المشاركة فرديًا أو ضمن فريق من 2 إلى 4 مطورين. نشجع العمل الجماعي لكن المشاركة الفردية مقبولة أيضًا.",
      icon: "👥",
    },
    {
      question: "هل المشاركة مجانية؟",
      answer:
        "نعم، المشاركة مجانية بالكامل. لا توجد أي رسوم للتسجيل أو المشاركة في الهاكاثون.",
      icon: "💰",
    },
    {
      question: "هل اللغة المستخدمة في المشاريع يجب أن تكون عربية؟",
      answer:
        "ليس بالضرورة، لكن المشروع يجب أن يخدم المبرمجين العرب أو يدعم المحتوى العربي البرمجي. يمكن كتابة الكود بأي لغة برمجة، لكن يفضل أن تكون الوثائق بالعربية أو الإنجليزية.",
      icon: "🌐",
    },
    {
      question: "ما هي أنواع المشاريع المقبولة؟",
      answer:
        "أي أداة مفتوحة المصدر تخدم المطورين العرب: مكتبات برمجية، أدوات CLI، محررات أكواد، منصات تعليمية، أدوات توثيق، أو أي شيء يسهل حياة المبرمج العربي.",
      icon: "🛠️",
    },
    {
      question: "كيف يتم تقييم المشاريع؟",
      answer:
        "يتم التقييم بناءً على: الإبداع والفكرة، جودة الكود، الفائدة للمجتمع العربي، الوثائق والتوثيق، وإمكانية الاستمرار والتطوير المستقبلي.",
      icon: "⭐",
    },
    {
      question: "هل يجب أن يكون المشروع جديدًا؟",
      answer:
        "نعم، يفضل أن يكون المشروع جديدًا ومطورًا خلال فترة الهاكاثون. لكن يمكنك استخدام مكتبات ومصادر موجودة مسبقًا كأساس لمشروعك.",
      icon: "🆕",
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="relative py-20 md:py-32 bg-dark-blue overflow-hidden">

      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <div className="max-w-4xl mx-auto">
          {/* Section Title */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-semibold text-white mb-4 uppercase tracking-wide">
              الأسئلة الشائعة ❓
            </h2>
            <div className="w-24 h-1 bg-yellow mx-auto rounded-full mb-6"></div>
            <p className="text-xl text-white/80">إجابات لأكثر الأسئلة شيوعًا</p>
          </div>

           {/* FAQ Items */}
           <div className="space-y-4">
             {faqs.map((faq, index) => (
               <div
                 key={index}
                 className="bg-white/5 backdrop-blur-lg rounded-2xl border border-white/10 hover:border-white/20 transition-all  overflow-hidden"
               >
                {/* Question */}
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-6 py-5 flex items-center justify-between text-right hover:bg-white/5 transition-all "
                >
                  <div className="flex items-center gap-4 flex-1">
                    <span className="text-3xl">{faq.icon}</span>
                    <h3 className="text-lg md:text-xl font-semibold text-white">
                      {faq.question}
                    </h3>
                  </div>

                  <div
                    className={`transform transition-transform  ${
                      openIndex === index ? "rotate-180" : ""
                    }`}
                  >
                    <svg
                      className="w-6 h-6 text-yellow"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </button>

                {/* Answer */}
                <div
                  className={`overflow-hidden transition-all  ${
                    openIndex === index
                      ? "max-h-96 opacity-100"
                      : "max-h-0 opacity-0"
                  }`}
                >
                  <div className="px-6 pb-5 pt-2">
                    <div className="pr-12 border-r-4 border-yellow">
                      <p className="text-white/80 leading-relaxed text-right">
                        <div dangerouslySetInnerHTML={{ __html: faq.answer }} />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Still Have Questions */}
          <div className="mt-12 text-center bg-white/5 rounded-2xl p-8 border border-white/10">
            <h3 className="text-2xl font-semibold text-white mb-3">
              لا تزال لديك أسئلة؟
            </h3>
            <p className="text-white/80 mb-6">
              تواصل معنا وسنكون سعداء بالإجابة على استفساراتك
            </p>
            <a
              href="mailto:contact@qimma.dev"
              className="inline-block px-8 py-3 bg-yellow text-dark-blue font-semibold rounded-xl hover:bg-yellow/90 transition-all  hover:scale-105"
            >
              تواصل معنا 📧
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
